module.exports = __webpack_public_path__ + "static/media/handbags_hero_mobile.119ace64.jpg";